import { UserMessage } from '../../../../types/UserMessage';
import { Text } from '../../../cdl/Text/Text';
import { BooleanStatus } from '../../../common/BooleanStatus/BooleanStatus';
import { DataSheet } from '../../../common/DataSheet/DataSheet';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

interface PersonalMemberSectionProps {
    user: UserMessage;
}

export const PersonalMemberSection = ({ user }: PersonalMemberSectionProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Text variant="title" as="h2">
                {translate('personalDetails.member.title')}
            </Text>

            <DataSheet>
                <DataSheet.Label>{translate('personalDetails.member.name')}</DataSheet.Label>
                <Text>{`${user.firstname} ${user.lastname}`.trim() || translate('user.userDetails')}</Text>

                <DataSheet.Label>{translate('user.mail')}</DataSheet.Label>
                <Text>{user.email}</Text>

                {user.phone ? (
                    <>
                        <DataSheet.Label>{translate('user.phone')}</DataSheet.Label>
                        <Text>{user.phone}</Text>
                    </>
                ) : null}

                <DataSheet.Heading marginTop={5}>{translate('user.emailPreferences')}</DataSheet.Heading>

                <DataSheet.Label>{translate('global.mailsettings.newsletter')}</DataSheet.Label>
                <BooleanStatus value={user.mailSettings.newsletter} />

                <DataSheet.Label>{translate('global.mailsettings.transactional')}</DataSheet.Label>
                <BooleanStatus value={user.mailSettings.transactional} />
            </DataSheet>
        </Box>
    );
};
